import React, { useEffect } from 'react';
import { Spin, Steps } from 'antd';

const { Step } = Steps;

interface MaterialOrderStatusStepsProps {
	status: string;
	onFormSubmit: (status: string) => void;
	loading: boolean;
	materialOrderLineItems: number;
}

const steps = [
	{
		key: 'Draft',
		title: 'Draft',
		description: 'Order created, pending negotiation with vendors',
	},
	{
		key: 'In Progress',
		title: 'In Progress',
		description: 'Vendors are reviewing and confirming the request',
	},
	{
		key: 'Submitted',
		title: 'Submitted',
		description: 'PO confirmed and sent to vendor, waiting for Delivery',
	},
];

export const MaterialOrderStatusSteps: React.FC<MaterialOrderStatusStepsProps> = ({
																																										status,
																																										loading,
																																										onFormSubmit,
																																										materialOrderLineItems,
																																									}) => {
	const [currentStep, setCurrentStep] = React.useState(0);

	useEffect(() => {
		const stepIndex = steps.findIndex(step => step.key === status);
		if (stepIndex !== -1) {
			setCurrentStep(stepIndex);
		}
	}, [status]);

	return (
		<Spin spinning={loading} tip="Loading...">
			<div style={{ margin: '1rem 0' }}>
				<Steps current={currentStep} size="small">
					{steps.map(step => (
						<Step
							key={step.key}
							title={step.title}
							description={step.description}
							onClick={() => {
								if(materialOrderLineItems > 0 && step.key === "In Progress") {
									setCurrentStep(steps.findIndex(s => s.key === step.key));
								}

								if (step.key === 'Draft') {
									setCurrentStep(steps.findIndex(s => s.key === step.key));
								}

								if (status !== 'Submitted') {
									onFormSubmit(step.key);
								}
							}}
							style={{
								cursor:
									status !== 'Submitted' && step.key !== status
										? 'pointer'
										: 'default',
							}}
						/>
					))}
				</Steps>
			</div>
		</Spin>
	);
};
